import { styled } from '../../Utilities';
import { FabricBase } from './Fabric.base';
import { getStyles } from './Fabric.styles';
/**
 * @deprecated This component is deprecated as of `@fluentui/react` version 8. Use `ThemeProvider` instead.
 */
export var Fabric = styled(FabricBase, getStyles, undefined, {
    scope: 'Fabric',
});
//# sourceMappingURL=Fabric.js.map